import { Attachment } from '~/data/useApplication';

/**
 * Finds the date when a decision letter was replaced by a newer letter of the same type.
 * @param currentLetter - The letter to check for replacement
 * @param allLetters - All decision letters for the application
 * @returns The date of the replacement letter, or undefined if no replacement exists
 */
export function getReplacedOnDate(currentLetter: Attachment, allLetters: Attachment[]): Date | undefined {
  if (!currentLetter.updatedAt) {
    return undefined;
  }

  const sameTypeLetters = allLetters
    .filter(
      (letter) => letter.type.code === currentLetter.type.code && letter.updatedAt && letter.key !== currentLetter.key // Exclude the current letter itself
    )
    .sort((a, b) => {
      const dateA = new Date(a.updatedAt ?? 0).getTime();
      const dateB = new Date(b.updatedAt ?? 0).getTime();
      return dateA - dateB;
    });

  // Find the first letter issued after the current one
  const currentDate = new Date(currentLetter.updatedAt).getTime();
  const replacementLetter = sameTypeLetters.find((letter) => {
    const letterDate = new Date(letter.updatedAt ?? 0).getTime();
    return letterDate > currentDate;
  });

  return replacementLetter?.updatedAt ? new Date(replacementLetter.updatedAt) : undefined;
}
